/////Icons
import CameraIcon from "../assets/icons/camera.png";
import DCMotorIcon from "../assets/icons/dcmotor.png";
import LineCurveIcon from "../assets/icons/linecurve.png";
import ServoIcon from "../assets/icons/servo.png";
import UltrasoundIcon from "../assets/icons/ultrasound.png";
import DepthSensorIcon from "../assets/icons/3dsensor.png";
import BrainAiIcon from "../assets/icons/brain_ai.png";
import LidarIcon from "../assets/icons/lidar.png";
import TTSIcon from "../assets/icons/tts.png";

//// Logos
import AndroidLogo from "../assets/logos/android.png";
import AngularLogo from "../assets/logos/angular.png";
import AwsLogo from "../assets/logos/aws.png";
import CloudflareLogo from "../assets/logos/cloudflare.png";
import Css3Logo from "../assets/logos/css3.png";
import DockerLogo from "../assets/logos/docker.png";
import ExpressLogo from "../assets/logos/express.png";
import FirebaseLogo from "../assets/logos/firebase.png";
import FlaskLogo from "../assets/logos/flask.png";
import FlutterLogo from "../assets/logos/flutter.png";
import GcpLogo from "../assets/logos/gcp.png";
import GitLogo from "../assets/logos/git.png";
import GooglecloudPlatformLogo from "../assets/logos/google_cloud_platform.png";
import GoogleMapsLogo from "../assets/logos/google_maps.png";
import GraphQLLogo from "../assets/logos/graphql.png";
import Html5Logo from "../assets/logos/html5.png";
import JavaLogo from "../assets/logos/java.png";
import JavaFXLogo from "../assets/logos/javafx.png";
import JavascriptLogo from "../assets/logos/javascript.png";
import JQueryLogo from "../assets/logos/jquery.png";
import IonicLogo from "../assets/logos/ionic.png";
import LaravelLogo from "../assets/logos/laravel.png";
import MatlabLogo from "../assets/logos/matlab.png";
import MongoDBLogo from "../assets/logos/mongodb.png";
import MySqlLogo from "../assets/logos/mysql.png";
import NodejsLogo from "../assets/logos/nodejs.png";
import OpenCVLogo from "../assets/logos/opencv.png";
import OpenCVAltLogo from "../assets/logos/opencv_alt_logo.png";
import PhpLogo from "../assets/logos/php.png";
import PushNotificationsLogo from "../assets/logos/pushnotifications.png";
import RaspberryPiLogo from "../assets/logos/raspberrypi.png";
import PythonLogo from "../assets/logos/python.png";
import ReactLogo from "../assets/logos/react.png";
import ReduxLogo from "../assets/logos/redux.png";
import RosLogo from "../assets/logos/ros.png";
import RosAltLogo from "../assets/logos/ros_alt_logo.png";

import TypescriptLogo from "../assets/logos/typescript.png";

import DialogflowCXLogo from "../assets/logos/dialogflowcx.png";
import JsonLogo from "../assets/logos/json.png";
import P5Logo from "../assets/logos/p5.png";
import PicovoiceLogo from "../assets/logos/picovoice.png";
import TuricreateLogo from "../assets/logos/turicreate.png";
import TurtlebotLogo from "../assets/logos/turtlebot.png";
import WebSocketsLogo from "../assets/logos/websockets.png";
import ThreejsLogo from "../assets/logos/threejs.png";
import BootstrapLogo from "../assets/logos/bootstrap.png";
import SassLogo from "../assets/logos/sass.png";
import FastlaneLogo from "../assets/logos/fastlane_logo.png";
import AdobeXDLogo from "../assets/logos/adobe_xd_logo.png";
import ArduinoLogo from "../assets/logos/arduino_logo.png";
import JiraLogo from "../assets/logos/jira_logo.png";
import SlackLogo from "../assets/logos/slack_logo.png";
import AppleLogo from "../assets/logos/apple-logo.png";
import GooglePlayLogo from "../assets/logos/google-play.png";
import BluetoothLogo from "../assets/logos/bluetooth.png";

///images
import EievMockUp1 from "../assets/projectimages/eiev_mockup_1-min.png";
import EievMockUp2 from "../assets/projectimages/eiev_mockup_2-min.png";
import ErcMockUp1 from "../assets/projectimages/erc_mockup_1-min.png";
import ErcMockUp2 from "../assets/projectimages/erc_mockup_2-min.png";
import KMZ from "../assets/projectimages/kmz.png";
import Sitt from "../assets/projectimages/sitt.png";
import Smartfix from "../assets/projectimages/smartfix.png";
import NomadicTribe from "../assets/projectimages/nomadic_tribe.png";
import MAWJ from "../assets/projectimages/mawj.png";
import BSeen from "../assets/projectimages/bseen.png";

// import AndroidTicTacToeHome from "../assets/projectimages/tictactoe_home-min.png";
// import AndroidTicTacToeGameplay from "../assets/projectimages/tictactoe_gameplay-min.png";
import AndroidTicTacToeSceenshot from "../assets/projectimages/android_tic_tac_toe_screenshot.png";
import TheaterBooking from "../assets/projectimages/theater-min.gif";
// import Frogger from "../assets/projectimages/frogger-min.gif";
import FroggerScreenshot from "../assets/projectimages/frogger_screenshot.gif";

// import SpaceInvaders from "../assets/projectimages/space_invaders-min.gif";
import SpaceInvadersScreenshot from "../assets/projectimages/space_invaders_screenshot.gif";

// import CommuniserveHome from "../assets/projectimages/communiserve_home-min.png";
// import CommuniserveMaps from "../assets/projectimages/communiserve_maps-min.png";
import CommuniserveScreenshots from "../assets/projectimages/coummuniserve_screenshot.png";
import CoinCounter from "../assets/projectimages/coin-counter-min.gif";
import FaceDetection from "../assets/projectimages/face-detection-min.gif";
import CollisionAvoidance from "../assets/projectimages/collison-avoidance-min.gif";
import ColorDetection from "../assets/projectimages/color-detection-min.gif";
import Gripper from "../assets/projectimages/grabber.gif";
import LineFollower from "../assets/projectimages/line-follower-min.gif";
import ReacherChatbot from "../assets/projectimages/reacher_chatbot.gif";
import ReacherCollisionAvoidance from "../assets/projectimages/reacher_collision_avoidance.gif";
import ReacherNavigation from "../assets/projectimages/reacher_navigation.gif";
import ReacherNavigationInternal from "../assets/projectimages/reacher_navigation_internal.gif";
import ReacherMappingInternal from "../assets/projectimages/reacher_mapping_internal.gif";
import ReacherLocalizationInternal from "../assets/projectimages/reacher_localization_internal.gif";

///// miscellaneous

import UCResearch from "../assets/miscellaneous/uc_undergraduate-min.png";
import Ega from "../assets/miscellaneous/ega-min.jpeg";
import MVPLogo from "../assets/miscellaneous/mvp_logo.jpeg";
import MVPLogoBlack from "../assets/miscellaneous/mvp_logo_black.jpeg";
import AduLogo from "../assets/miscellaneous/adu_logo.png";
import EievLogo from "../assets/miscellaneous/eiev-logo.png";
import ERCLogo from "../assets/miscellaneous/erc-logo.png";
import KMZLogo from "../assets/miscellaneous/kmz_app_logo.png";
import NomadicLogo from "../assets/miscellaneous/nomadic_app_logo.png";
import SittLogo from "../assets/miscellaneous/sitt_app_logo.png";
import SmartfixLogo from "../assets/miscellaneous/smartfix_app_logo.png";
import BseenLogo from "../assets/miscellaneous/bseen_app_logo.png";
import MAWJLogo from "../assets/miscellaneous/mawj_app_logo.png";
import IOTBanner from "../assets/miscellaneous/iot_banner.jpg";
import WebDesignBanner from "../assets/miscellaneous/web_design_banner.png";
import CodeBanner from "../assets/miscellaneous/code_banner.png";

/// intro assets
import profileImg from "../assets/miscellaneous/profile.jpeg";
import linkedin from "../assets/social/linkedin.png";
import github from "../assets/social/github.png";

class Assets {
  /////Icons
  static readonly CAMERA_ICON: string = CameraIcon;
  static readonly DCMOTOR_ICON: string = DCMotorIcon;
  static readonly LINECURVE_ICON: string = LineCurveIcon;
  static readonly SERVO_ICON: string = ServoIcon;
  static readonly ULTRASOUND_ICON: string = UltrasoundIcon;
  static readonly DEPTH_SENSOR_ICON: string = DepthSensorIcon;
  static readonly BRAIN_AI_ICON: string = BrainAiIcon;
  static readonly LIDAR_ICON: string = LidarIcon;
  static readonly TTS_ICON: string = TTSIcon;

  public static getAllIconsUrls = (): string[] => [
    this.CAMERA_ICON,
    this.DCMOTOR_ICON,
    this.LINECURVE_ICON,
    this.SERVO_ICON,
    this.ULTRASOUND_ICON,
    this.DEPTH_SENSOR_ICON,
    this.BRAIN_AI_ICON,
    this.LIDAR_ICON,
    this.TTS_ICON,
  ];
  ////Logos
  static readonly ANDROID_LOGO: string = AndroidLogo;
  static readonly ANGULAR_LOGO: string = AngularLogo;
  static readonly AWS_LOGO: string = AwsLogo;
  static readonly CLOUDFLARE_LOGO: string = CloudflareLogo;
  static readonly CSS3_LOGO: string = Css3Logo;
  static readonly CSS_LOGO: string = AndroidLogo;
  static readonly DOCKER_LOGO: string = DockerLogo;
  static readonly EXPRESS_LOGO: string = ExpressLogo;
  static readonly FIREBASE_LOGO: string = FirebaseLogo;
  static readonly FLASK_LOGO: string = FlaskLogo;
  static readonly FLUTTER_LOGO: string = FlutterLogo;
  static readonly GCP_LOGO: string = GcpLogo;
  static readonly GIT_LOGO: string = GitLogo;
  static readonly GOOGLECLOUD_PLATFORM_LOGO: string = GooglecloudPlatformLogo;
  static readonly Google_MAPS_LOGO: string = GoogleMapsLogo;
  static readonly GRAPHQL_LOGO: string = GraphQLLogo;
  static readonly HTML5_LOGO: string = Html5Logo;
  static readonly JAVA_LOGO: string = JavaLogo;
  static readonly JAVAFX_LOGO: string = JavaFXLogo;
  static readonly JAVASCRIPT_LOGO: string = JavascriptLogo;
  static readonly JQUERY_LOGO: string = JQueryLogo;
  static readonly IONIC_LOGO: string = IonicLogo;
  static readonly LARAVEL_LOGO: string = LaravelLogo;
  static readonly MATLAB_LOGO: string = MatlabLogo;
  static readonly MONGODB_LOGO: string = MongoDBLogo;
  static readonly MYSQL_LOGO: string = MySqlLogo;
  static readonly NODEJS_LOGO: string = NodejsLogo;
  static readonly OPENCV_LOGO: string = OpenCVLogo;
  static readonly OPENCV_ALT_LOGO: string = OpenCVAltLogo;
  static readonly PHP_LOGO: string = PhpLogo;
  static readonly PUSH_NOTIFICATIONS_LOGO: string = PushNotificationsLogo;
  static readonly PYTHON_LOGO: string = PythonLogo;
  static readonly RASPBERRY_PI_LOGO: string = RaspberryPiLogo;
  static readonly REACT_LOGO: string = ReactLogo;
  static readonly REDUX_LOGO: string = ReduxLogo;
  static readonly ROS_LOGO: string = RosLogo;
  static readonly ROS_ALT_LOGO: string = RosAltLogo;
  static readonly TYPSCRIPT_LOGO: string = TypescriptLogo;
  static readonly THREEJS_LOGO: string = ThreejsLogo;
  static readonly BOOTSTRAP_LOGO: string = BootstrapLogo;
  static readonly SASS_LOGO: string = SassLogo;
  static readonly FASTLANE_LOGO: string = FastlaneLogo;
  static readonly ADOBE_XD_LOGO: string = AdobeXDLogo;
  static readonly ARDUINO_LOGO: string = ArduinoLogo;
  static readonly JIRA_LOGO: string = JiraLogo;
  static readonly SLACK_LOGO: string = SlackLogo;

  static readonly DIALOGFLOWCX_LOGO: string = DialogflowCXLogo;
  static readonly JSON_LOGO: string = JsonLogo;
  static readonly P5JS_LOGO: string = P5Logo;
  static readonly PICOVOICE_LOGO: string = PicovoiceLogo;
  static readonly TURICREATE_LOGO: string = TuricreateLogo;
  static readonly TURTLEBOTLOGO: string = TurtlebotLogo;
  static readonly WEBSOCKETS_LOGO: string = WebSocketsLogo;

  static readonly GOOGLEPLAYLOGO: string = GooglePlayLogo;
  static readonly APPLELOGO: string = AppleLogo;
  static readonly BLUETOOTHLOGO: string = BluetoothLogo;

  ////project images
  static readonly EIEV_HOME: string = EievMockUp1;
  static readonly EIEV_SOCIAL: string = EievMockUp2;
  static readonly ERC_HOME: string = ErcMockUp1;
  static readonly ERC_PROJECT_SHARE: string = ErcMockUp2;
  static readonly KHAYMATZAMAN_SCREENSHOT: string = KMZ;
  static readonly SITT_SCREENSHOT: string = Sitt;
  static readonly MAWJ_SCREENSHOT: string = MAWJ;
  static readonly SMARTFIX_SCREENSHOT: string = Smartfix;
  static readonly BSEEN_SCREENSHOT: string = BSeen;
  static readonly NOMADIC_TRIBE_SCREENSHOT: string = NomadicTribe;

  // static readonly TIC_TAC_TOE_HOME: string = AndroidTicTacToeHome;
  // static readonly TIC_TAC_TOE_GAMEPLAY: string = AndroidTicTacToeGameplay;
  static readonly TIC_TAC_TOE_SCREENSHOT: string = AndroidTicTacToeSceenshot;

  static readonly THEATER_GIF: string = TheaterBooking;
  // static readonly FROGGER_GIF: string = Frogger;
  static readonly FROGGER_SCREENSHOT: string = FroggerScreenshot;

  // static readonly SPACEINVADERS_GIF: string = SpaceInvaders;
  static readonly SPACEINVADERS_SCREENSHOT: string = SpaceInvadersScreenshot;

  // static readonly COUMMUNISERVE_HOME: string = CommuniserveHome;
  // static readonly COUMMUNISERVE_MAPS: string = CommuniserveMaps;
  static readonly COUMMUNISERVE_SCREENSHOT: string = CommuniserveScreenshots;

  static readonly COINCOUNTER_GIF: string = CoinCounter;
  static readonly FACEDETECTION_GIF: string = FaceDetection;
  static readonly COLLISION_AVOIDANCE_GIF: string = CollisionAvoidance;
  static readonly COLOR_DETECTION_GIF: string = ColorDetection;
  static readonly GRIPPER_GIF: string = Gripper;
  static readonly LINE_FOLLOWER_GIF: string = LineFollower;
  static readonly REACHER_CHATBOT_GIF: string = ReacherChatbot;
  static readonly REACHER_COLLISION_AVOIDANCE_GIF: string =
    ReacherCollisionAvoidance;
  static readonly REACHER_NAVIGATION_GIF: string = ReacherNavigation;
  static readonly REACHER_LOCALIZATION_INTERNAL_GIF: string =
    ReacherLocalizationInternal;
  static readonly REACHER_MAPPING_INTERNAL_GIF: string = ReacherMappingInternal;
  static readonly REACHER_NAVIGATION_INTERNAL_GIF: string =
    ReacherNavigationInternal;

  public static getAllProjectImages = (): string[] => [
    this.EIEV_SOCIAL,
    this.EIEV_HOME,
    this.ERC_HOME,
    this.ERC_PROJECT_SHARE,
    this.KHAYMATZAMAN_SCREENSHOT,
    this.SITT_SCREENSHOT,
    this.MAWJ_SCREENSHOT,
    this.SMARTFIX_SCREENSHOT,
    this.BSEEN_SCREENSHOT,
    this.NOMADIC_TRIBE_SCREENSHOT,
    // this.TIC_TAC_TOE_HOME,
    // this.TIC_TAC_TOE_GAMEPLAY,
    this.TIC_TAC_TOE_SCREENSHOT,
    this.THEATER_GIF,
    // this.FROGGER_GIF,
    this.FROGGER_SCREENSHOT,
    // this.SPACEINVADERS_GIF,
    this.SPACEINVADERS_SCREENSHOT,
    // this.COUMMUNISERVE_HOME,
    // this.COUMMUNISERVE_MAPS,
    this.COUMMUNISERVE_SCREENSHOT,
    this.COINCOUNTER_GIF,
    this.FACEDETECTION_GIF,
    this.COLLISION_AVOIDANCE_GIF,
    this.COLOR_DETECTION_GIF,
    this.GRIPPER_GIF,
    this.LINE_FOLLOWER_GIF,
    this.REACHER_CHATBOT_GIF,
    this.REACHER_COLLISION_AVOIDANCE_GIF,
    this.REACHER_NAVIGATION_GIF,
    this.REACHER_LOCALIZATION_INTERNAL_GIF,
    this.REACHER_MAPPING_INTERNAL_GIF,
    this.REACHER_NAVIGATION_INTERNAL_GIF,
  ];

  /// miscellaneous

  static readonly UC_RESEARCH: string = UCResearch;
  static readonly EGA_COMPETITION: string = Ega;
  static readonly MVP_LOGO: string = MVPLogo;
  static readonly MVP_LOGO_BLACK: string = MVPLogoBlack;
  static readonly ADU_LOGO: string = AduLogo;
  static readonly EIEV_LOGO: string = EievLogo;
  static readonly ERC_LOGO: string = ERCLogo;
  static readonly KMZ_LOGO: string = KMZLogo;
  static readonly SITT_LOGO: string = SittLogo;
  static readonly SMARTFIX_LOGO: string = SmartfixLogo;
  static readonly BSEEN_LOGO: string = BseenLogo;
  static readonly MAWJ_LOGO: string = MAWJLogo;
  static readonly NOMADIC_LOGO: string = NomadicLogo;
  static readonly IOT_BANNER: string = IOTBanner;
  static readonly WEBDESIGN_BANNER: string = WebDesignBanner;
  static readonly CODE_BANNER: string = CodeBanner;

  /// intro assets////
  static readonly PROFILE_IMAGE: string = profileImg;
  static readonly GITHUB_LOGO: string = github;
  static readonly LINKEDIN_LOGO: string = linkedin;
  public static getAllIntroAssets = (): string[] => [
    this.PROFILE_IMAGE,
    this.GITHUB_LOGO,
    this.LINKEDIN_LOGO,
  ];
}

export default Assets;
